import request from '@/utils/request'

// 图片验证码
export function sendImgCaptcha(data) {
  return request({
    url: '/api/captcha/',
    method: 'get',
    data
  })
}

// 手机验证码
export function sendPhoneCaptcha(data) {
  return request({
    url: '/api/forgot/password/sendMobileCode/',
    method: 'post',
    data
  })
}

// 邮箱验证码
export function sendEmailCaptcha(data) {
  return request({
    url: '/api/forgot/password/sendMailCode/',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/captcha.js